import { ListItem } from '@vueling-ng/vy-ds/src/lib/components/globals/list';

export const LinksMenu: ListItem[] = [
  {
    label: 'home_component.cards.bookings',
    icon: 'ds-icon-settings-large'
  } as ListItem,
  {
    id: 'agency_credit',
    label: 'home_component.cards.agency_credit',
    href: '/agencyCredit',
    icon: 'ds-icon-flight-credit-large',
    target: '_self'
  } as ListItem,
  {
    id: 'cac',
    label: 'home_component.cards.cac',
    icon: 'ds-icon-call-center-large',
    href: 'https://www.vueling.com/es/somos-vueling/contacto/gestiones?helpCenterFlow=ClaimStatus',
    target: '_blank'
  } as ListItem,
  {
    id: 'invoices',
    label: 'home_component.cards.invoices',
    icon: 'ds-icon-bill-large',
    href: 'https://pub.vueling.com/Vueling.NewInvoice.GAC.WebUI/',
    target: '_blank'
  } as ListItem
];

export enum LinksMenuItemId {
  AgencyCredit = 'agency_credit',
  CAC = 'cac',
  Invoices = 'invoices',
  Groups = 'groups',
  Bookings = 'bookings',
  ManageAccount = 'manage_account'
}
